'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import LandsController from "./controller/lands";
import LandModalCreateController from "./controller/landModalCreate";
import LandModalSelectController from "./controller/landModalSelect";
import LandCategoryFilterController from "./controller/landCategoryFilter";
import LandTableDirective from "./directive/landTable";
import LandService from "./service/land";

export default angular.module('investmentProject.land', [])
    .controller('LandsController', LandsController)
    .controller('LandModalCreateController', LandModalCreateController)
    .controller('LandModalSelectController', LandModalSelectController)
    .controller('LandCategoryFilterController', LandCategoryFilterController)
    .directive('landTable', LandTableDirective)
    .factory('LandService', LandService)
    .name;
